import createPlugin from './createPlugin'

import PanelsRenderer from './Renderer/PanelsRenderer'

const panelsPlugin = settings =>
    createPlugin({
        Renderer: PanelsRenderer,
        ...settings,
    })

const panels = panelsPlugin()
export default panels

export { panelsPlugin, PanelsRenderer }
